import React from 'react';

// Truthful capability states (spec: "Do not claim a feature is live if it
// isn't"). Every pane, tool, or action a specialized shell shows must be
// labeled with one of these -- never silently presented as if it worked.
export type CapabilityState = 'LIVE' | 'AVAILABLE' | 'DESIGN_SLOT' | 'BLOCKED' | 'DEGRADED';

export const CAPABILITY_STATES: readonly CapabilityState[] = Object.freeze([
  'LIVE', 'AVAILABLE', 'DESIGN_SLOT', 'BLOCKED', 'DEGRADED',
]);

const LABEL: Record<CapabilityState, string> = {
  LIVE: 'Live',
  AVAILABLE: 'Available',
  DESIGN_SLOT: 'Unavailable',
  BLOCKED: 'Blocked',
  DEGRADED: 'Degraded',
};

const CLASS: Record<CapabilityState, string> = {
  LIVE: 'ozira-capability--live',
  AVAILABLE: 'ozira-capability--available',
  DESIGN_SLOT: 'ozira-capability--design-slot',
  BLOCKED: 'ozira-capability--blocked',
  DEGRADED: 'ozira-capability--degraded',
};

export function capabilityLabel(state: CapabilityState): string {
  return LABEL[state];
}

export function CapabilityBadge({ state, note }: { state: CapabilityState; note?: string }) {
  return (
    <span className={`ozira-capability-badge ${CLASS[state]}`} title={note}>
      {LABEL[state]}
    </span>
  );
}
